import { render, staticRenderFns } from "./UserInviteForm.vue?vue&type=template&id=7524902c&scoped=true"
import script from "./UserInviteForm.vue?vue&type=script&lang=js"
export * from "./UserInviteForm.vue?vue&type=script&lang=js"
import style0 from "./UserInviteForm.vue?vue&type=style&index=0&id=7524902c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7524902c",
  null
  
)

export default component.exports